import { render, staticRenderFns } from "./PasswordUpdate.vue?vue&type=template&id=4385e83a&"
import script from "./PasswordUpdate.vue?vue&type=script&lang=ts&"
export * from "./PasswordUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports